import React from 'react';
import { Link } from 'react-router-dom';
import { SocialLinks } from './SocialLinks';
import { Logo } from './Logo';

export const Footer: React.FC = () => (
  <footer className="site-footer">
    <div className="wrap footer-inner">
      <div>
        <Link to="/" className="brand footer-brand" aria-label="Mustafa Gürses — yazılımcı ana sayfa">
          <Logo markSize={28} />
        </Link>
        <p className="footer-copy">
          Mustafa Gürses · Yazılımcı · Full Stack Developer · Gaziantep
        </p>
      </div>
      <SocialLinks />
    </div>
  </footer>
);
